import { render } from "./ValidateTokenView.vue?vue&type=template&id=c465cd1a"
import script from "./ValidateTokenView.vue?vue&type=script&lang=js"
export * from "./ValidateTokenView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__